import ajaxContactForm from "./ajaxContactForm";

const activateBliKundeForm = (formWrapperId) => {
  if (jQuery(formWrapperId).length === 0) return false;
  const $form = jQuery(formWrapperId);

  // Enable async features
  ajaxContactForm(formWrapperId);

  const setButtonEnabledStatus = (button, enabled) => {
    if (enabled) {
      button.removeAttr("disabled");
    } else {
      button.attr("disabled", "disabled");
    }
  };

  const nextButton = jQuery(".js-next-step", $form);
  const backButton = jQuery(".js-prev-step", $form);
  const step1 = jQuery(".js-first-step", $form);
  const step2 = jQuery(".js-second-step", $form);

  // Check if at least one checkbox is selected
  jQuery(".c-contact-form input", $form)
    .unbind("change")
    .bind("change", () => {
      setButtonEnabledStatus(
        nextButton,
        jQuery(".c-contact-form input:checked", $form).length > 0
      );
    });

  //Moving to the next step
  nextButton.unbind("click").bind("click", () => {
    step1.addClass("hidden");
    step2.removeClass("hidden");
  });

  // Return to the previous step
  backButton.unbind("click").bind("click", () => {
    step1.removeClass("hidden");
    step2.addClass("hidden");
  });
};

export default activateBliKundeForm;
